import { messages as defaultMessages } from "./messages.fr.js";

export function validateForm(data, options = {}) {
  const fields = {};
  const collectPhone = options.collectPhone ?? true;
  const phoneRequired = options.phoneRequired ?? false;
  const collectMessage = options.collectMessage ?? true;
  const messageRequired = options.messageRequired ?? false;
  const messages = options.messages || defaultMessages;

  if (!data.name.trim()) {
    fields.name = messages.fieldNameRequired;
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email.trim())) {
    fields.email = messages.fieldEmailInvalid;
  }

  if (collectPhone) {
    const phone = data.phone.trim();
    // Obligatoire si demandé ; sinon validé seulement s'il est renseigné.
    if ((phoneRequired && !phone) || (phone && phone.length < 3)) {
      fields.phone = messages.fieldPhoneRequired;
    }
  }

  if (collectMessage && messageRequired && !(data.message || "").trim()) {
    fields.message = messages.fieldMessageRequired;
  }

  return {
    valid: Object.keys(fields).length === 0,
    fields
  };
}
